import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export const getTrackingMetaData = (displayTitle: string): TrackingMetaData => ({
  context: {
    contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.INFINITE_LIST,
    trackingId: 'based-on-your-taste',
    contentContainerDisplayName: displayTitle,
  },
})
